// @ts-nocheck
import React, { useState } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Gravatar from 'react-gravatar';
import { search } from '../../../../api/userApi';
import { useTranslation } from 'react-i18next';

type SearchProps = {
  autoFocus?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
  onChange: (selected: any[]) => void;
  defaultValue?: string;
};

function Search({
  autoFocus,
  onFocus,
  onBlur,
  onChange,
  defaultValue,
}: Readonly<SearchProps>) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const handleSearch = (query: any) => {
    setIsLoading(true);

    search(query)
      .then((items) => {
        setOptions(items);
        setIsLoading(false);
      })
      .catch(() => {
        setOptions([]);
        setIsLoading(false);
      });
  };

  const renderResult = (data: any) => {
    return (
      <>
        <Gravatar
          email={data?.username}
          size={26}
          rating="pg"
          default="retro"
          className="img-circle me-3 ms-2"
        />
        <div className="item-content">
          <span>{data.fullName}</span>
          <br />
          {data.company}
        </div>
      </>
    );
  };

  return (
    <AsyncTypeahead
      autoFocus={autoFocus}
      id="search-typeahead"
      isLoading={isLoading}
      labelKey="fullName"
      minLength={2}
      onSearch={handleSearch}
      options={options}
      placeholder={t('Search')}
      renderMenuItemChildren={renderResult}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      defaultInputValue={defaultValue}
    />
  );
}
export default Search;
